import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})


export class decimalplaceHandler {
  
    static round_LineAmt = 2;
    static round_TotalAmt = 2;
    static round_InventoryCost = 5;
    static round_UnitPrice = 2;
    static round_Qty = 2;
    static round_none = -1;
  
    static dpSellingPrice_Med = 1;
    static dpSellingPrice = 1;
    static dpPurchPrice = 1;
    static dpBuyingQty = 2;
    static dpStockQty = 2;
    static dpServiceQty = 1;
    static dpSellingQtyPrescrption = 2;
    static dpSellingQtyBilling = 1;
    static dpLineAmt = 1;
    static dpTotalAmt = 1;
    static dpInventoryCost = 4;
    static dpdiscount = 6;
    static dpUnitConv = 2;

    static dpNoDP = 0;


  
    convertToValue(value: number, dp: number, rd: number) {
  
      let rd_value: number;
      let final_value: string;
  
      rd_value = value;

      if (rd !== -1) {
        rd_value = this.round(value, rd);
      }
  
      final_value = parseFloat(rd_value.toString()).toFixed(dp);
  
      return Number(final_value);
    }

    convertToValueStr(value: number, dp: number, rd: number) {
  
        let rd_value: number;
        let final_value: string;
    
        rd_value = value;
  
        if (rd !== -1) {
          rd_value = this.round(value, rd);
        }
    
        final_value = parseFloat(rd_value.toString()).toFixed(dp);
        // final_value = rd_value.toFixed(dp);
    
        return final_value;
      }
  
  
    round(number, precision) {
      const factor = Math.pow(10, precision);
      const tempNumber = number * factor;
      const roundedTempNumber = Math.round(tempNumber);
      return roundedTempNumber / factor;
    };
  
  
  
  }